import React from "react";
import useFetch from "../../hooks/useFetch";
import LoadingCard from "../../elements/LoadingCard";
import EspCard from "./EspCard";
import EspErrorCard from "./EspErrorCard";

export default function ClaimsByEntities() {
  const { isLoading, data, error } = useFetch("claims-by-entities");

  if (isLoading) return <LoadingCard />;

  if (error) {
    return (
      <EspErrorCard error={error}>
        <EspErrorCard.Copy />
      </EspErrorCard>
    );
  }

  return (
    <EspCard data={data} tag={<EspCard.CurrencyTag />}>
      <EspCard.Section>
        <EspCard.Copy>
          <EspCard.FeaturedDataPoint />{" "}
          <span>WAC dollars were submitted by {data.meta.secondary_values[0]} covered entities.</span>
        </EspCard.Copy>
        <EspCard.Interval />
      </EspCard.Section>
    </EspCard>
  );
}
